import ReactGA from 'react-ga';

export default function analytics() {
    ReactGA.initialize('UA-#########');
    ReactGA.pageview(window.location.pathname + window.location.search);
    return;
}

export const EventTracker = ({category, action, label}) => {
    ReactGA.initialize('UA-#########');
    ReactGA.event({
        category: category,
        action: action,
        label: label
    });
}
